export default __webpack_public_path__ + "static/media/canopy.286385ee.svg";